import React, { useEffect, useState, Fragment } from 'react'
import styled from 'styled-components'
import Head from 'next/head'

import NdsThemeProvider from '@ntuctech/devex-tangram/Theme/NdsThemeProvider'
import { headers } from '../../../../lib/fetch'
import { SCREEN_SIZE } from '../../../../lib/Media'
import { get } from '../../../../lib/loyaltyFetch'
import LocalStorageService from '../../../../utils/LocalStorageService'

import Layout from '../../../../components/Layout/Layout'
import ScreenManager from '../../../../components/Loyalty/ScreenManager/ScreenManager'

import { AccountConsumer } from '../../../../components/AccountProvider'
import GlobalContext from '../../../../components/GlobalContext'
import { EventTrackingConsumer } from '../../../../components/EventTrackingProvider'

const __JWC_ID__ = 1

const Wrapper = styled.div`
  font-size: 0.875rem;
  line-height: 1.5;

  ${SCREEN_SIZE.From.Desktop} {
    font-size: 1rem;
  }
`

const JWC = ({
  accountData = {},
  categoryList,
  isLoggedIn,
  organizationData,
  track,
}) => {
  const [data, setData] = useState()
  const [error, setError] = useState()
  const [loaded, setLoaded] = useState(false)

  let status = isLoggedIn ? 'pending' : 'guest'

  useEffect(() => {
    get(`programmes/${__JWC_ID__}`, {
      ...(isLoggedIn && { headers: headers() }),
    })
      .then(res => {
        setData(res)
        setError(null)
      })
      .catch(err => {
        setError(err)
      })
      .finally(() => setLoaded(true))

    if (!isLoggedIn) {
      LocalStorageService.setItem('jwcGuest', 'true')
    } else if (LocalStorageService.getItem('jwcGuest') === 'true') {
      LocalStorageService.removeItem('jwcGuest')
    }
  }, [isLoggedIn])

  if (isLoggedIn) {
    if (data && data.membership && data.membership.cardNumber) {
      status = 'member'
    } else {
      status = 'user'
    }
  }

  return (
    <GlobalContext.Consumer>
      {({ remoteConfig }) => (
        <Fragment>
          <Head>
            <title>Love Wine? Join the FairPrice Just Wine Club Today!</title>
            <meta property="og:type" content="website" />
            <meta
              property="og:title"
              content="Love Wine? Join the FairPrice Just Wine Club Today!"
            />
            <meta property="og:site_name" content="FairPrice" />
            <meta
              name="description"
              key="meta_description"
              content="Join FairPrice's Just Wine Club to enjoy exclusive 8% discounts on wine purchases, invitations to special events, and more. Unlock your wine perks today!"
            />
          </Head>
          <Layout
            categoryList={categoryList}
            organizationData={organizationData}
          >
            <Wrapper>
              <ScreenManager
                loaded={loaded}
                status={status}
                data={data}
                error={error}
                accountData={accountData}
                remoteConfig={remoteConfig}
                track={track}
              />
            </Wrapper>
          </Layout>
        </Fragment>
      )}
    </GlobalContext.Consumer>
  )
}

const JWCWrapper = props => (
  <NdsThemeProvider>
    <EventTrackingConsumer>
      {({ track }) => (
        <AccountConsumer>
          {accProps => <JWC {...accProps} {...props} track={track} />}
        </AccountConsumer>
      )}
    </EventTrackingConsumer>
  </NdsThemeProvider>
)

export default JWCWrapper
